import { DefaultImageProps } from './types';
import { APP_STORE_IMAGE_URL } from './urls';

export const AppStoreImage = ({ className, ...props }: DefaultImageProps) => (
  <img
    className={className}
    src={APP_STORE_IMAGE_URL}
    alt="app-store"
    {...props}
  />
);
